import { mdiArrowDownBoldOutline, mdiArrowUpBoldOutline } from "@mdi/js";
import { ColumnDef, SoftButton, SoftIcon } from "@soft-db/ui";

export function useTableOrdering<T>(el: Ref<T[]>): ColumnDef<T> {
	function moveQuery(index: number, direction: "left" | "right") {
		if (el.value.length < 2) return;

		const allData = [...el.value];
		if (index === -1) return;

		const elementToMove = allData.splice(index, 1)[0];
		const to = direction === "left" ? index - 1 : index + 1;
		allData.splice(to, 0, elementToMove);

		el.value = [...allData];
	}

	return {
		id: "ordering",
		meta: {
			style: {
				minWidth: "1px",
				width: "1px",
			},
		},
		cell: ({ row }) => (
			<div class="flex space-x-2">
				<SoftButton
					disabled={row.index === el.value.length - 1}
					xs
					ghost
					onClick={() => moveQuery(row.index, "right")}
				>
					<SoftIcon small>{mdiArrowDownBoldOutline}</SoftIcon>
				</SoftButton>
				<SoftButton
					disabled={row.index === 0}
					xs
					ghost
					onClick={() => moveQuery(row.index, "left")}
				>
					<SoftIcon small>{mdiArrowUpBoldOutline}</SoftIcon>
				</SoftButton>
			</div>
		),
	};
}
